/**
 * Loading spinner component for route-level Suspense fallbacks
 */

import React from 'react'

import { useTranslation } from '@platform/i18n/hooks/useTranslation'

export const LoadingSpinner: React.FC = () => {
  const { t } = useTranslation('common')
  return (
    <div className="min-h-screen bg-crypto-dark flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-8 h-8 border-4 border-crypto-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-crypto-text text-sm">{t('common.loading')}</p>
      </div>
    </div>
  )
}
